import type { LinkProps } from '@mui/material'
import Link from '@mui/material/Link'
import { forwardRef } from 'react'

interface ExternalLinkProps {
  color?: 'primary' | 'secondary'
  androidSdk: string
  iosSdk: string
  samplePsdBanner: string
  integrationGuide: string
}

const externalLinks: ExternalLinkProps = {
  androidSdk:
    'https://developer.fyber.com/hc/en-us/articles/360010867717-Android-SDK-Integration',
  iosSdk:
    'https://developer.fyber.com/hc/en-us/articles/360010971118-iOS-SDK-Integration',
  samplePsdBanner: '/sample-template.psd',
  integrationGuide:
    'https://developer.digitalturbine.com/hc/en-us/articles/4404313469201-Setting-Up-DT-Offer-Wall#setting-up-placements-0-19',
}

type Props = Omit<LinkProps, 'href'> & {
  to: keyof ExternalLinkProps
}

const ExternalLink = forwardRef((props: Props, _) => {
  return (
    <Link
      href={externalLinks[props.to]}
      underline="hover"
      color={props.color ?? 'primary'}
      target="_blank"
      rel="noopener"
    >
      {props.children}
    </Link>
  )
})

export default ExternalLink
